import App from '@/models/App'

export default class OrderingOrdererDestinationCompany extends App {
    static get entity() {
        return 'OrderingOrdererDestinationCompanies'
    }

    static all() {
        return this.query().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            name: this.attr(''),
            country: this.attr(''),
            address: this.attr(''),
            email: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            fetch(params) {
                return this.get(`/ordering/orderer/destinationCompanies`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
